export default "__VITE_ASSET__Dd_NQ8rv__"